import type { Product } from "./data/products.ts";

/** 商品列表和评论都是静态 JSON,放在 public/api 下,由 CDN 直接返回 */
export async function fetchProducts(): Promise<Product[]> {
  const r = await fetch("/api/products.json");
  if (!r.ok) throw new Error(`products: ${r.status}`);
  return r.json();
}

export interface Review { user: string; rating: number; text: string; date: string }

export async function fetchReviews(slug: string): Promise<Review[]> {
  const r = await fetch(`/api/reviews/${slug}.json`);
  if (!r.ok) throw new Error(`reviews: ${r.status}`);
  return r.json();
}

export interface SalesPoint { date: string; orders: number; revenue: number }

export async function fetchSales(): Promise<SalesPoint[]> {
  const r = await fetch("/api/sales.json");
  if (!r.ok) throw new Error(`sales: ${r.status}`);
  return r.json();
}
